var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWashAt30Degree = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8.74 7.36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#313332"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.66 2.31a.84.84 0 0 0 -1 .19l.39.37c.06-.06.18-.17.46 0l-1 4h-4.36l-.76-3.2-.26-1.1a.76.76 0 0 1 .3 0 1.48 1.48 0 0 1 .62.32l.31-.44a1.92 1.92 0 0 0 -.86-.45 1.18 1.18 0 0 0 -.49 0l-.49-2-.52.15 1.73 7.21h5.27l1.74-7.23-.52-.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.21 3.92a1 1 0 0 0 .83.4 1 1 0 0 0 1.06-1 .75.75 0 0 0 -.4-.65 1 1 0 0 0 .54-.84.73.73 0 0 0 -.79-.73 1.18 1.18 0 0 0 -.83.4.09.09 0 0 0 0 .12l.22.26a.07.07 0 0 0 .11 0 .65.65 0 0 1 .42-.22.29.29 0 0 1 .3.3.51.51 0 0 1 -.56.5h-.23a.1.1 0 0 0 -.1.09v.29a.07.07 0 0 0 .07.09h.15a.42.42 0 0 1 .46.41.45.45 0 0 1 -.46.48.53.53 0 0 1 -.43-.22.09.09 0 0 0 -.14 0l-.24.22a.11.11 0 0 0 .02.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.23 4.32c.84 0 1.31-.79 1.31-2 0-.74-.33-1.21-.86-1.21-.8 0-1.3.79-1.3 2 0 .73.32 1.21.85 1.21zm.38-2.66c.21 0 .32.27.32.68 0 .82-.24 1.44-.62 1.44-.22 0-.32-.27-.32-.69.01-.81.23-1.43.62-1.43z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWashAt30Degree);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "WashAt30Degree.5ab3bc3e72318c42a95d031a3186ec92.svg";